import { DEFAULT_LOCALE, LOCALE_KEY } from "config/constants";
import {
  API_SEARCH_PATH,
  ARTICLE_TYPE_PATH,
  CATEGORIES_PATH,
  NEW_ARTICLES_PATH,
  SITEMAP_PATH,
  SUPPORT_GROUP_PATH,
  UPDATED_ARTICLES_PATH,
} from "config/route-constants";
import React, { FC, useEffect } from "react";
import { Route, Routes as Switch, useLocation } from "react-router-dom";
import ArticlesByCategory from "view/Page/ArticlesByCategory";
import ArticlesByDate from "view/Page/ArticlesByDate";
import SearchResultsPage from "view/Page/SearchResults";
import Sitemap from "view/Page/Sitemap";

import { useAppContext } from "../../AppContext";
import ClickstreamHelper, { getFullUrl } from "../../lib/helpers/clickstream-helper";
import { MetadataType } from "../../lib/interfaces/metadata";
import LegoPage from "../Page/LegoPage";

const Router: FC = () => {
  const location = useLocation();
  const { clickStreamUrls, setClickStreamUrls } = useAppContext();
  const language: string = window.localStorage.getItem(LOCALE_KEY) || DEFAULT_LOCALE;
  useEffect(() => {
    setClickStreamUrls((prevState) => {
      return {
        url: getFullUrl(window.location.href),
        referalUrl: prevState.url,
      };
    });
  }, [location, setClickStreamUrls]);

  useEffect(() => {
    ClickstreamHelper.createClickStreamMetric({
      language: language,
      ...clickStreamUrls,
    });
  }, [clickStreamUrls]);

  return (
    <Switch>
      <Route path="/" element={BeforeRouteActionsWrapper(<LegoPage path="/landing-page" key={Date.now()} />)} />
      <Route path={SITEMAP_PATH} element={BeforeRouteActionsWrapper(<Sitemap key={Date.now()} />)} />
      <Route path={API_SEARCH_PATH} element={BeforeRouteActionsWrapper(<SearchResultsPage key={Date.now()} />)} />
      <Route path={NEW_ARTICLES_PATH} element={BeforeRouteActionsWrapper(<ArticlesByDate filter="created_at" />)} />
      <Route path={UPDATED_ARTICLES_PATH} element={BeforeRouteActionsWrapper(<ArticlesByDate filter="updated_at" />)} />
      <Route
        path={CATEGORIES_PATH}
        element={BeforeRouteActionsWrapper(<ArticlesByCategory type={MetadataType.CATEGORY} />)}
      />
      <Route
        path={ARTICLE_TYPE_PATH}
        element={BeforeRouteActionsWrapper(<ArticlesByCategory type={MetadataType.ARTICLE_TYPE} />)}
      />
      <Route
        path={SUPPORT_GROUP_PATH}
        element={BeforeRouteActionsWrapper(<ArticlesByCategory type={MetadataType.SUPPORT_GROUP} />)}
      />
      {/* Changed key to 'window.location.pathname' to ensure that
     the route is not re-triggerd when 'window.location.hash' is changed.
     This prevents 'Tab' widget from refreshing the window everytime the tab is switched
     e.g. if the url changes from '/page#tab-body-1' to '/page#tab-body-2', it won't
     re-trigger a route change since '/page' (window.location.pathname) is same even though
     window.location.hash has change from '#tab-body-1' to '#tab-body-2' */}
      <Route path="/*" element={BeforeRouteActionsWrapper(<LegoPage key={window.location.pathname} />)} />
    </Switch>
  );
};

/**
 * Perform certain actions before routing to the desired component
 */
const BeforeRouteActionsWrapper = (componentToRender: React.ReactNode) => {
  /**
   * Dispatches a 'locationchange' event whenever the router changes routes.
   * Will be used to detect url changes on a page
   */
  window.dispatchEvent(new Event("locationchange"));

  return componentToRender;
};

export default Router;
